import './new-quote-accommodation.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormQuoteAccommodation from "../form-quote-accommodation/form-quote-accommodation";
import { useNewQuoteAccommodation } from './new-quote-accommodation.hook';

export function NewQuoteAccommodation() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewQuoteAccommodation();

  return (
    <div id="NewQuoteAccommodation" className="quote-accommodation">
      <HeaderContent
        title={<h1>New Quote Accommodation</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormQuoteAccommodation />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewQuoteAccommodation;